import { getError } from "@/utils/helpers";
import StatuteService from "@/services/statute/StatuteService";

export const namespaced = true;

export const state = {
  adjustments: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_ADJUST(state, adjustments) {
    state.adjustments = adjustments;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getStatus({ commit }, famId) {
    commit("SET_LOADING", true);

    StatuteService.showAdjustAll(famId)
      .then((response) => {
        commit("SET_ADJUST", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_ADJUST", []);
  },
};
export const getters = {
  adjustments: (state) => {
    return state.adjustments;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
